module.exports = __webpack_public_path__ + "img/discord.7594b796.svg";